import { Pipe, PipeTransform } from '@angular/core';
import { utils } from 'src/app/shared';

@Pipe({
  name: 'filterModules',
  standalone: false,
})
export class FilterModulesPipe implements PipeTransform {
  transform(data: any[], filterText: string): any[] {
    if (!data || !filterText) {
      return data;
    }

    filterText = utils.normalize(filterText);

    return data.filter(module => {
      return module.label && utils.normalize(module.label).includes(filterText);
    });
  }
}
